const textFormat = (params) => {
  if (!params.text) return "";

  if (params.html && !params.hidebbcode) {
    params.text = params.text.replace(/\[b\]([\s\S]+?)\[\/b\]/g, "<b>$1</b>");
    params.text = params.text.replace(/\[i\]([\s\S]+?)\[\/i\]/g, "<i>$1</i>");
    params.text = params.text.replace(
      /\[strike\]([\s\S]+?)\[\/strike\]/g,
      "<s>$1</s>"
    );
    params.text = params.text.replace(/\*\*(.+?)\*\*/g, "<b>$1</b>");
    params.text = params.text.replace(/\*(.+)\*/g, "<i>$1</i>");
    params.text = params.text.replace(/\\~~(.+)\\~~/g, "<s>$1</s>");
  }

  if (params.hidebbcode) {
    // si on prend pas en compte le bbcode on supprime les balises
    params.text = params.text.replace(/\[b\]/g, "");
    params.text = params.text.replace(/\[\/b\]/g, "");
    params.text = params.text.replace(/\[i\]/g, "");
    params.text = params.text.replace(/\[\/i\]/g, "");
    params.text = params.text.replace(/\[strike\]/g, "");
    params.text = params.text.replace(/\[\/strike\]/g, "");
  }

  // viré car faille sécurité
  // params.text = params.text
  // .replace(/&amp;/g, "&")
  // .replace(/&lt;/g, "<")
  // .replace(/&gt;/g, ">")
  // .replace(/&quot;/g, '"')
  // .replace(/&#039;/g, "'");

  if (params.html) {
    // params.text = params.text.replace(/\/n/g, "<br />");
    params.text = params.text.replace(/\n/g, "<br />");
  }

  if (params.html && !params.nohref) {
    // Only linkify URLs that start exactly with https://choualbox.com
    params.text = params.text.replace(
      /(https:\/\/choualbox\.com[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi,
      '<a href="$1" target="_blank" rel="nofollow noopener" class="text-secondary">$1</a>'
    );
  }

  if (params.html) {
    params.text = params.text.replace(
      /\[spoiler\]([\s\S]+?)\[\/spoiler\]/g,
      "<spoiler>$1</spoiler>"
    );
  }

  if (params.tagnsfw && params.tagnsfw == 1) {
    params.text = "<nsfw>NSFW</nsfw> " + params.text;
  }

  return params.text;
};

// à utiliser seulement dans les TextInput
const convertHtml = (html) => {
  if (!html) return html;

  html = html
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#039;/g, "'");

  // déconne car on peut plus faire de balise spoiler dans les formulaires
  // html = html
  // .replace(/&amp;/g, "&")
  // .replace(/&lt;/g, "<")
  // .replace(/&gt;/g, ">")
  // .replace(/&quot;/g, '"')
  // .replace(/&#039;/g, "'")
  // .replace(/\[spoiler\]([\s\S]+?)\[\/spoiler\]/g, "<spoiler>****</spoiler>");

  return html;
};

function escape(unescaped) {
  return unescaped
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

function unescape(escaped) {
  return escaped
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#039;/g, "'");
}

function pluriel(num) {
  const retour = num > 1 ? "s" : "";
  return retour;
}

const slug = (str) =>
  str
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/[\s_-]+/g, "-")
    .replace(/^-+|-+$/g, "");

const truncateUrl = (url, maxLength = 30) => {
  // If the URL is shorter than the maxLength, return the original URL
  if (url.length <= maxLength) return url;

  // Otherwise, return the truncated URL plus "..."
  return url.substring(0, maxLength) + "...";
};

function isUrl(s) {
  var regexp =
    /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
  return regexp.test(s);
}

const getDomainFromUrl = (url) => {
  if (!isUrl(url)) return url;
  return url.split("/")[2].replace("www.", "").substring(0, 20);
};

function getMobileOs() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "windows";
  }

  if (/android/i.test(userAgent)) {
    return "android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "ios";
  }

  return "unknown";
}

export {
  textFormat,
  convertHtml,
  escape,
  unescape,
  pluriel,
  slug,
  truncateUrl,
  getDomainFromUrl,
  getMobileOs,
};
